import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const companyDataClassName = DataClassName.COMPANY
const companyEndpoint = PisaDataClassEndpoint.COMPANY

export function pisaCompanyDataClass(attributes: DataAttributeDefinitions) {
  return provideDataClass(companyDataClassName, {
    title: companyDataClassName,
    restApi: createPisaRestApiConfig(companyEndpoint),
    attributes,
  })
}
